import { Button, Typography } from '@mui/material';
import axios from 'axios';
import { z } from 'zod';
import FieldFactory from '@/classes/FieldFactory';
import { useTitle } from '@/contexts/AppContext';
import { useDialogs, useToast } from '@/contexts/DialogContext';

export default function SetupGmail() {
  useTitle('Setup Gmail');
  const { prompt } = useDialogs();
  const toast = useToast();

  const onEdit = () => {
    prompt({
      title: 'Enter Gmail Password',
      fields: [
        FieldFactory.text('gmail_password').withInputProps({
          type: 'password',
        }),
      ],
      schema: z.object({
        gmail_password: z.string(),
      }),
      onSubmit: (v) => axios.put('/api/me', v),
    }).then(() => {
      toast('Successfully updated gmail password');
    });
  };

  return (
    <div>
      <Typography variant="subtitle1" sx={{ mb: 2 }}>
        Configure Avail to send from your Gmail account by generating an app password{' '}
        <a
          href="https://myaccount.google.com/apppasswords"
          target="_blank"
          rel="nofollow noreferrer"
        >
          here
        </a>{' '}
        and then entering it below.
      </Typography>
      <Button type="button" onClick={onEdit} variant="contained">
        Enter Password
      </Button>
    </div>
  );
}
